import { render, staticRenderFns } from "./main-cost.vue?vue&type=template&id=75a7a63c&scoped=true"
import script from "./main-cost.vue?vue&type=script&lang=js"
export * from "./main-cost.vue?vue&type=script&lang=js"
import style0 from "./main-cost.vue?vue&type=style&index=0&id=75a7a63c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a7a63c",
  null
  
)

export default component.exports